{
  "name": "zeytal",
  "version": "1.4.0",
  "type": "module",
  "private": false,
  "publishConfig": {
    "provenance": false,
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/provok-exe/zeytal"
  },
  "homepage": "https://zeytal.com/docs",
  "description": "From Figma to code in only one command line. Zeytal allows designers and developers to sync their work by auto-generating front-end code from their Figma files. Generate variables, styles, and SVGs from Figma.",
  "license": "MIT",
  "keywords": [
    "figma",
    "zeytal",
    "design-system",
    "tailwind",
    "tailwindcss",
    "svg",
    "css",
    "components",
    "assets",
    "ui",
    "scss",
    "sass",
    "less"
  ],
  "bin": {
    "zeytal": "./bin/zeytal"
  },
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./schema/zeytal.json": "./schema/zeytal.json"
  },
  "files": [
    "dist",
    "schema"
  ],
  "scripts": {
    "dev": "tsup --watch ./src",
    "build": "tsup",
    "lint": "eslint . --max-warnings 0",
    "lint:fix": "pnpm lint --fix",
    "pretty": "pnpm lint:fix && pnpx prettier --write .",
    "check-types": "tsc --noEmit",
    "clean": "rm -rf ./.turbo ./node_modules ./dist ./schema"
  },
  "dependencies": {
    "c12": "^3.0.3",
    "chalk": "^5.4.1",
    "colorette": "^2.0.20",
    "commander": "^14.0.0",
    "dotenv": "^16.4.5",
    "is-unicode-supported": "^2.1.0",
    "node-fetch": "^3.3.2",
    "ora": "^8.2.0",
    "semver": "^7.7.2",
    "strip-ansi": "^7.1.0",
    "svgo": "^4.0.0",
    "trash": "^9.0.0"
  },
  "devDependencies": {
    "@endgame/eslint-config": "workspace:*",
    "@endgame/prettier-config": "workspace:*",
    "@endgame/typescript-config": "workspace:*",
    "@endgame/utils": "workspace:*",
    "@types/node": "^22.15.3",
    "@types/semver": "^7.7.0",
    "@zeytal/assets": "workspace:*",
    "@zeytal/figma": "workspace:*",
    "@zeytal/kit": "workspace:*",
    "@zeytal/tokens": "workspace:*",
    "@zeytal/types": "workspace:*",
    "tsup": "^8.3.6"
  }
}
